var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_787",
    "data-name": "Caminho 787",
    d: "M16.1,15.551l-1.267-1.267L16.1,13.018a.384.384,0,0,0-.543-.543l-1.267,1.267-1.267-1.267a.384.384,0,1,0-.543.543l1.267,1.267-1.267,1.267a.371.371,0,0,0,0,.543.382.382,0,0,0,.543,0l1.267-1.267,1.267,1.267a.386.386,0,0,0,.543,0A.382.382,0,0,0,16.1,15.551Z",
    transform: "translate(-5.913 -5.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_788",
    "data-name": "Caminho 788",
    d: "M8.375,4.048a4.325,4.325,0,1,1-3.06,1.267,4.3,4.3,0,0,1,3.06-1.267m0-.673a5,5,0,1,0,5,5,5,5,0,0,0-5-5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCircle);
export default __webpack_public_path__ + "static/media/IconCloseCircle.7c3c6b88c7cbfef0baad7165c0b66f5d.svg";
export { ForwardRef as ReactComponent };